import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { customAxiosGetFunction } from 'utils/axiosFunction';
import { nvl } from 'utils/nvl';

const useGraphLogData = (title, moduleIdx) => {
  const history = useHistory();
  const [logData, setLogData] = useState(null);

  useEffect(() => {
    const getLogDataForPopupGraph = async () => {
      let url = '';

      switch (title) {
        case '가스':
          url = '/api/gas/newestDataOne';
          break;
        default:
          return;
      }

      const response = await customAxiosGetFunction(history, url, { params: { moduleIdx: moduleIdx } });
      setLogData(nvl(response, null));
    };

    getLogDataForPopupGraph();

    const timer = window.setInterval(() => {
      getLogDataForPopupGraph();
    }, Number(5000));

    return () => {
      window.clearInterval(timer);
    };
  }, []);

  return logData;
};

export default useGraphLogData;
